import React, { FC } from 'react';
import MuiAvatarGroup, { AvatarGroupProps as MuiAvatarGroupProps } from '@material-ui/lab/AvatarGroup';
import { Uds } from '../../types';

export type AvatarGroupProps = Uds<MuiAvatarGroupProps & {}>;

export const AvatarGroup: FC<React.PropsWithChildren<AvatarGroupProps>> = ({ dataTest, ...props }) => (
  <MuiAvatarGroup data-test={dataTest} {...props} />
);
